import script from "./debtFunds.vue?vue&type=script&setup=true&lang=js"
export * from "./debtFunds.vue?vue&type=script&setup=true&lang=js"

import "./debtFunds.vue?vue&type=style&index=0&id=18e4167a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e4167a"]])

export default __exports__